import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    title: obj?.title,
    type: obj?.content_type,
    status: obj?.status,
    body: obj?.body,
    excerpt: obj?.excerpt,
    featuredImage: obj?.featured_image,
    featuredImageAlt: obj?.featured_image_alt,
    authorId: obj?.author_id,
    publishedAt: obj?.published_at,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

const toSnakeCase = (obj) => {
  return {
    title: obj?.title,
    content_type: obj?.type,
    status: obj?.status,
    body: obj?.body,
    excerpt: obj?.excerpt,
    featured_image: obj?.featuredImage,
    featured_image_alt: obj?.featuredImageAlt,
    author_id: obj?.authorId,
    published_at: obj?.publishedAt || (obj?.status === 'published' ? new Date()?.toISOString() : null),
  };
};

const getAll = async () => {
  const { data, error } = await supabase
    ?.from('content')
    ?.select(`
      *,
      user_profiles!content_author_id_fkey(
        id,
        full_name,
        role
      )
    `)
    ?.order('created_at', { ascending: false });

  if (error) throw error;
  return data?.map((item) => ({
    ...toCamelCase(item),
    authorRole: item?.user_profiles?.role,
    authorName: item?.user_profiles?.full_name,
  })) || [];
};

const getById = async (id) => {
  const { data, error } = await supabase
    ?.from('content')
    ?.select(`
      *,
      user_profiles!content_author_id_fkey(
        id,
        full_name,
        role
      )
    `)
    ?.eq('id', id);

  if (error) throw error;
  if (!data?.[0]) return null;
  return {
    ...toCamelCase(data[0]),
    authorRole: data[0]?.user_profiles?.role,
    authorName: data[0]?.user_profiles?.full_name,
  };
};

const create = async (contentData) => {
  const snakeCaseData = toSnakeCase(contentData);
  const { data, error } = await supabase?.from('content')?.insert([snakeCaseData])?.select()?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const update = async (id, contentData) => {
  const snakeCaseData = toSnakeCase(contentData);
  const { data, error } = await supabase?.from('content')?.update(snakeCaseData)?.eq('id', id)?.select()?.single();

  if (error) throw error;
  return toCamelCase(data);
};

const deleteMethod = async (id) => {
  const { error } = await supabase?.from('content')?.delete()?.eq('id', id);

  if (error) throw error;
};

const subscribeToChanges = (callback) => {
  const channel = supabase?.channel('content')?.on('postgres_changes', { event: '*', schema: 'public', table: 'content' }, (payload) => {
      callback(payload);
    })?.subscribe();

  return () => supabase?.removeChannel(channel);
};

export const contentService = {
  getAll,
  getById,
  create,
  update,
  delete: deleteMethod,
  subscribeToChanges,
};
